import { Accordion, Card, Flex, Row, Title } from '@wyz/ui';
import * as React from 'react';
import { IUserCustomer } from '~/common/types';
import { SearchPreview } from '~/purchase/components';
import { IBaseSearchFormSchema } from '~/purchase/types';
type Props = {
  title: React.ReactNode;
  customer: IUserCustomer;
  searchQuery: IBaseSearchFormSchema | undefined;
  opened: boolean;
  onToggle: () => void;
};
function AccordionWrapper({
  title,
  children,
  searchQuery,
  customer,
  opened,
  onToggle,
}: React.PropsWithChildren<Props>) {
  return (
    <Row className='mt-section'>
      <Card>
        <Accordion.Container
          flush
          activeKey={opened ? '0' : undefined}
          onSelect={onToggle}
        >
          <Accordion.Item eventKey='0'>
            <Accordion.Header>
              <Flex alignItems='center' wrap='wrap' className='w-100'>
                <Title heading='xl' weight='bold'>
                  {title}
                </Title>
                {!opened && (
                  <div className='flex-1 self-end'>
                    <SearchPreview
                      customer={customer}
                      searchQuery={searchQuery}
                    />
                  </div>
                )}
              </Flex>
            </Accordion.Header>
            <Accordion.Body>{children}</Accordion.Body>
          </Accordion.Item>
        </Accordion.Container>
      </Card>
    </Row>
  );
}

export default AccordionWrapper;
